import JourneyRow from './JourneyRow';
import { Caption, CardBox, CardHeader, CardTitle, Segmented } from './styles';
import { GridRow } from './tableStyles';
import SectionState from '../shared/SectionState';
import { useLifecycleUrlState } from '../useLifecycleUrlState';
import { Scroll } from '../shared/Scroll';

import useAuth from '@/hooks/useAuth';
import { JourneyChanges, LifecycleJourney } from '@/services/lifecycleAPI';

const HEADINGS = [
  '',
  'Journey',
  'Enters / exits',
  'Steps',
  'On',
  'SMS',
  'In journey',
  'Goal rate vs holdout',
  'STOP rate',
  'Cost / goal',
];

type Props = {
  journeys: LifecycleJourney[];
  onUpdate: (key: string, changes: JourneyChanges) => Promise<void>;
};

const JourneyTable = ({ journeys, onUpdate }: Props) => {
  const { currentAdminIsTenantAdminRole } = useAuth();
  const { params, update } = useLifecycleUrlState<'journeys'>();
  const { window, open } = params;

  return (
    <CardBox aria-labelledby="journeysTitle" data-testid="journeyTable">
      <CardHeader>
        <CardTitle id="journeysTitle">Journeys</CardTitle>
        <Caption>
          {journeys.length} journeys. Click a name to see its settings, sends
          and exits.
        </Caption>
        <Segmented
          aria-label="Stats window"
          role="group"
          style={{ marginLeft: 'auto' }}
        >
          <button
            aria-pressed={window === '7d'}
            data-testid="statsWindow7d"
            type="button"
            onClick={() => update({ window: '7d' }, { replace: true })}
          >
            Last 7 days
          </button>
          <button
            aria-pressed={window === '30d'}
            data-testid="statsWindow30d"
            type="button"
            onClick={() => update({ window: '30d' }, { replace: true })}
          >
            Last 30 days
          </button>
        </Segmented>
      </CardHeader>
      {journeys.length === 0 ? (
        <SectionState
          caption="Journeys appear here once they are set up."
          mode="empty"
          title="No journeys yet"
        />
      ) : (
        <Scroll>
          <GridRow head>
            {HEADINGS.map((heading, index) => (
              <span key={index}>{heading}</span>
            ))}
          </GridRow>
          {journeys.map((journey) => (
            <JourneyRow
              canEdit={currentAdminIsTenantAdminRole}
              isOpen={open === journey.journey_key}
              journey={journey}
              key={journey.journey_key}
              window={window}
              onToggle={() =>
                update(
                  {
                    open:
                      open === journey.journey_key
                        ? null
                        : (journey.journey_key as typeof open),
                  },
                  { replace: true },
                )
              }
              onUpdate={onUpdate}
            />
          ))}
        </Scroll>
      )}
    </CardBox>
  );
};

export default JourneyTable;
